export const salesOrgHelper = {
  methods: {
    getSalesOrgAbbrFromId(id){
      if(id >= 1 && id <= 4){
        var salesOrgAbbreviations = ["MA", "ME", "MS", "RP"]
        return salesOrgAbbreviations[id - 1];
      }
      else{
        return "Not Found"
      }
    }
  }
}
